@if (kind() === "soon") {
  <i class="pi pi-clock"></i>
}
<span>{{ label() }}</span>
